import type { BlockCommandDependencies } from './BlockBaseCommand';
import { BlockBaseCommand } from './BlockBaseCommand';
import { updateContentObjectViaSocket } from '../grid/reduxStore/saveHandlers';
import { updateGridContentObjectBlockState } from '../grid/reduxStore/editorSlice';
import { setSaveStatusBasedOnApiResponse } from '../grid/reduxStore/saveStatusSlice';
import { AcknowledgmentResponseStatus } from '../../../services/socket/SocketEvents';

export class ContentObjectChangedCommand extends BlockBaseCommand {
  private readonly blockId: string;
  private readonly sectionId: string;
  private readonly oldContent: Record<string, unknown>;
  private readonly newContent: Record<string, unknown>;

  constructor(
    blockId: string,
    sectionId: string,
    oldContent: Record<string, unknown>,
    newContent: Record<string, unknown>,
    dependencies: BlockCommandDependencies
  ) {
    super(dependencies);
    this.blockId = blockId;
    this.sectionId = sectionId;
    this.oldContent = oldContent;
    this.newContent = newContent;
  }

  getCurrentBlockId(): string {
    return this.blockId;
  }

  async undo(): Promise<boolean> {
    return this.updateContent(this.oldContent);
  }

  async redo(): Promise<boolean> {
    return this.updateContent(this.newContent);
  }

  private async updateContent(content: Record<string, unknown>): Promise<boolean> {
    try {
      this.setSaving();

      const response = await updateContentObjectViaSocket(this.socketClient, {
        blockId: this.blockId,
        content: content,
        userId: this.userId,
      });

      this.dispatch(setSaveStatusBasedOnApiResponse(response));
      if (this.checkDocumentLockStatus(response.errorCode)) {
        return false;
      }

      if (response.status === AcknowledgmentResponseStatus.OK) {
        this.dispatch(
          updateGridContentObjectBlockState({
            blockId: this.blockId,
            sectionId: this.sectionId,
            content: content,
          })
        );
        return true;
      }

      return false;
    } catch (error) {
      console.error('Failed to update content object:', error);
      this.setNotSaved();
      return false;
    }
  }
}
